import { MantineTheme } from "@mantine/core";
import { DataMapMarkerProps, latLng, ValuesRecord } from "@mcurros2/microm";


export function TiendasViewMarkerRenderer(record: ValuesRecord, position: latLng, theme: MantineTheme): DataMapMarkerProps | null {

    const tienda = record[2] as string;

    const markerProps: DataMapMarkerProps = {
        position: position,
        title: `${tienda}`,
        assignColorByValue: undefined,
    }

    return markerProps;
}